/* eslint-disable import/prefer-default-export */
export const PRISMIC_ENDPOINT = 'https://stonebethany.cdn.prismic.io/api/v2';
